// eslint-disable-next-line
import React from 'react';
import { connect } from 'react-redux';

// import classNames from 'classnames';
import * as MuiCore from '@material-ui/core';
import AccountBoxIcon from '@material-ui/icons/Settings';
import WorkIcon from '@material-ui/icons/FormatListBulleted';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import PhoneIcon from '@material-ui/icons/Phone';
import * as coreSelectors from '../core/selectors';
import * as ServiceIcons from '../service/Icons';
import VIPIcon from '@material-ui/icons/Beenhere';
import Logo from './Logo';
import { useHistory, useLocation } from 'react-router-dom';
import { canAccessChatActivity, canAccessTexts, canAccessBlockedContacts, getCurrentScreen, userHasRole } from 'utils';
import { USER_ACCOUNT_ROLE_KEYS } from 'constants/account.roles.constants';
import { NEW_SCREENS, SPECIAL_ACCESS_SCREENS } from 'constants/screens.constants';
import * as serviceSelectors from 'service/selectors';
import ProfileDropdown from './Appbar/ProfileDropdown';
import ServiceButtons from './Appbar/ServiceButtons';
import { MobileVisible } from './ScreenViewWrappers';



const SideDrawerContainer = MuiCore.styled(MuiCore.Drawer)(({ theme }) => ({
    height: '100vh',
    '& .MuiDrawer-paper': {
        backgroundColor: theme.brandingColors.rubyDarkPurple,
        width: `calc(100px + ${theme.sizes.drawerWidth})`,
    },
    [theme.breakpoints.up('md')]: {
        position: 'relative',
        '& .MuiDrawer-paper': {
            width:theme.sizes.drawerWidth,
        },
    }
}))

const Center = MuiCore.styled(MobileVisible)(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
}))
function SideDrawer({ user, availableScreens, drawerOpen, setDrawerOpen, isMobile }) {
    const history = useHistory()
    const location = useLocation()
    const checkPermission = (screen) => {
        if(screen ==='chat'){
            return canAccessChatActivity(user)
        }
        if(screen==='text'){
            return canAccessTexts(user)
        }
        if(screen === 'callhandling'){
            const hasGrasshopperGlobalRole = user?.userAccountRoles?.some(
                role => role.userRoleKey === 'GRASSHOPPERGLOBAL'
            );
            if (!hasGrasshopperGlobalRole) {
                return false;
            }
            
            const hasFeatureEnabledAccount = user?.userAccountRoles?.some(
                role => role.userRoleKey === 'GRASSHOPPERGLOBAL' && role.showCallHandling === 'Y'
            );
            return hasFeatureEnabledAccount;
        }
        if (!SPECIAL_ACCESS_SCREENS.includes(screen)) {
            return true;
        }
        var enable = false;
        if (userHasRole(user, USER_ACCOUNT_ROLE_KEYS.GLOBALADMIN)) {
            enable = true
        }
        return enable;
    }
    // Check if the length equality check is required here
    const checkBillingAdmin = () => {
        return user.userAccountRoles.filter(role => role.userRoleKey === 'BILLING_ADMIN').length !== user.userAccountRoles.length
    }
    const checkPartner = () => {
        return userHasRole(user, USER_ACCOUNT_ROLE_KEYS.PARTNERS) || userHasRole(user, USER_ACCOUNT_ROLE_KEYS.GRASSHOPPER) || userHasRole(user, USER_ACCOUNT_ROLE_KEYS.GRASSHOPPERSMS)
    }
    const showIntegration = () => {
        return userHasRole(user, USER_ACCOUNT_ROLE_KEYS.GLOBALADMIN) || userHasRole(user, USER_ACCOUNT_ROLE_KEYS.GRASSHOPPERGLOBAL)
    }
    const screen = getCurrentScreen(availableScreens, location.pathname);
    const buttonStyles = { fontFamily: 'Sofia-bold', color: '#fff' }
    return (
        <SideDrawerContainer
            anchor="left"
            variant={isMobile ? 'temporary' : 'permanent'}
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
        >
            <MuiCore.List component="nav" style={{ border: '0px' }} >
                <MuiCore.ListItem
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: 30
                    }}
                    component="div"
                    // className={classes.mobileLogoHolder} 
                    onClick={() => { checkBillingAdmin() && history.push('/'); }}
                >
                    <Logo />
                </MuiCore.ListItem>
                {availableScreens.map(availableScreen => {
                    // console.log("The screen name is", screen)
                    // let badge = 0;
                    if (checkPermission(availableScreen.name)) {
                        if (availableScreen.name === 'activity') {
                            // badge = unreadMessageCount;
                        }
                        if (availableScreen.name === 'texts') {
                            // badge = unreadChatCount;
                        }
                        return <MuiCore.ListItem component="div" key={availableScreen.name} disabled={!checkBillingAdmin()} button={true} selected={screen === availableScreen.name}
                            // className={classes.sideMenuItems}
                            onClick={() => {
                                setDrawerOpen(false);
                                if (availableScreen.label === 'Account') {
                                    // this.setState({accountMenuOpen : true })
                                    history.push('/profile');
                                } else {
                                    history.push(availableScreen.path);
                                    // this.toggleDrawer(false)
                                }
                            }} >
                            <MuiCore.Grid item style={{ width: '100%', textAlign: 'center' }}
                            //  ref={availableScreen.label === 'Account' ? this.accountButtonRef : null}
                            >
                                <MuiCore.Grid item style={{ textAlign: 'center' }}>
                                    {availableScreen.label === 'Dashboard' && <ServiceIcons.DashboardIcon fontSize='large' style={{ color: screen === 'dashboard' ? '#fff' : '#AB6D98' }} />}
                                    {availableScreen.label === 'Call Handling' && <PhoneIcon fontSize='large' style={{ color: screen === 'callhandling' ? '#fff' : '#AB6D98' }} />}
                                    {availableScreen.label === 'Activity' && <WorkIcon fontSize='large' style={{ color: screen === 'activity' ? '#FFF' : '#AB6D98' }} />}
                                    {availableScreen.label === 'Text' && <ServiceIcons.SMSIcon  style={{ color: screen === 'text' ? '#FFF' : '#AB6D98' }} />}
                                    {availableScreen.label === 'Chat' && <ServiceIcons.ChatIcon fontSize='large' style={{ color: screen === 'chat' ? '#fff' : '#AB6D98' }} />}
                                    {availableScreen.label === 'Status' && <RecordVoiceOverIcon fontSize='large' style={{ color: screen === 'status' ? '#FFF' : '#AB6D98' }} />}
                                    {availableScreen.label === 'Contacts' && <ServiceIcons.RubyContactsIcon style={{ color: screen === 'contacts' ? '#FFF' : '#AB6D98', marginTop: 10 }} />}
                                    {availableScreen.label === 'Account' && <AccountBoxIcon fontSize='large' style={{ color: screen === 'profile' ? '#FFF' : '#AB6D98' }} />}
                                    {availableScreen.label === 'VIP Contacts' && <VIPIcon fontSize='large' style={{ color: screen === 'VIP Contacts' ? '#FFF' : '#AB6D98' }} />}
                                    <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', color: availableScreen.name === screen ? '#FFF' : '#AB6D98', fontSize: 12, textAlign: 'center' }}>
                                        {availableScreen.label}
                                    </MuiCore.Typography>
                                </MuiCore.Grid>
                            </MuiCore.Grid>
                        </MuiCore.ListItem>
                    } else {
                        return null;
                    }
                }
                )}
                {Object.values(NEW_SCREENS).map(screen=>screen.name).includes(screen) &&
                    <MuiCore.Grid >
                        <MuiCore.Divider style={{ height: 2, backgroundColor: '#fff', marginBottom: 5, marginLeft: 10, marginRight: 10 }} />
                        <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', color: NEW_SCREENS.COMPANY.name === screen ? '#FFF' : '#AB6D98', fontSize: 12, textAlign: 'center', marginTop: 5, cursor: checkBillingAdmin() && 'pointer' }} onClick={() => { setDrawerOpen(false); checkBillingAdmin() && history.push("/company") }}>Company</MuiCore.Typography>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', color: NEW_SCREENS.SETTINGS.name === screen? '#FFF' : '#AB6D98', fontSize: 12, textAlign: 'center', marginTop: 5, cursor: checkBillingAdmin() && 'pointer' }} onClick={() => { setDrawerOpen(false); checkBillingAdmin() && history.push('/settings') }}>Settings</MuiCore.Typography>
                        {canAccessBlockedContacts(user) && <MuiCore.Typography style={{ lineHeight:1.1, fontFamily: 'Sofia-bold', color: NEW_SCREENS.BLOCKED.name === screen ? '#FFF' : '#AB6D98', fontSize: 12, textAlign: 'center', marginTop: 5, cursor: canAccessBlockedContacts(user) && 'pointer' }} onClick={() => { setDrawerOpen(false); canAccessBlockedContacts(user) && history.push('/blocked') }}>Blocked Contacts</MuiCore.Typography>}
                        {!checkPartner() && userHasRole(user, USER_ACCOUNT_ROLE_KEYS.GLOBALADMIN) && <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', color: NEW_SCREENS.REPORTS.name === screen ? '#FFF' : '#AB6D98', fontSize: 12, textAlign: 'center', marginTop: 5, cursor: checkBillingAdmin() && 'pointer' }} onClick={() => { setDrawerOpen(false); checkBillingAdmin() && history.push('/reports') }}>Insights</MuiCore.Typography>}
                        {!checkPartner() && userHasRole(user, USER_ACCOUNT_ROLE_KEYS.GLOBALADMIN) && <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', color: NEW_SCREENS.BILLING.name === screen ? '#FFF' : '#AB6D98', fontSize: 12, textAlign: 'center', marginTop: 5, cursor: 'pointer' }} onClick={() => { setDrawerOpen(false); checkBillingAdmin() && history.push('/billing') }}>Billing</MuiCore.Typography>}
                        {showIntegration() && <MuiCore.Typography style={{ fontFamily: 'Sofia-bold', color: NEW_SCREENS.INTEGRATIONS.name === screen ? '#FFF' : '#AB6D98', fontSize: 12, textAlign: 'center', marginTop: 5, cursor: checkBillingAdmin() && 'pointer' }} onClick={() => { setDrawerOpen(false); checkBillingAdmin() && history.push('/integrations') }}>Integrations</MuiCore.Typography>}
                    </MuiCore.Grid>

                }
                <MobileVisible>
                    <MuiCore.Divider style={{ marginTop: '10px' }} />
                    <Center>
                        <ServiceButtons isMobile buttonStyles={buttonStyles} />
                        <ProfileDropdown setDrawerOpen={setDrawerOpen} buttonStyles={buttonStyles} />
                    </Center>
                </MobileVisible>
            </MuiCore.List>
        </SideDrawerContainer>
    )
}



const mapStateToProps = (state) => {
    return ({
        user: coreSelectors.getUser(state),
        availableScreens: coreSelectors.getAvailableScreens(state),
        unreadMessageCount: serviceSelectors.getUnreadMessageCount(state),
        unreadChatCount: serviceSelectors.getUnreadChatCount(state),

    });
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(SideDrawer)